import { apiSlice } from "../../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Department"],
});

export const departmentsApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getDepartment: builder.query({
      query: (parameter) => `/department/${parameter}`,
      providesTags: ["Department"],
    }),
    getDepartmentsPaginated: builder.query({
      query: ({ page = 1, per_page = 20, q = "" } = {}) => ({
        url: `/department/all`,
        params: { page, per_page, ...(q ? { q } : {}) },
      }),
      providesTags: ["Department"],
    }),
    createDepartment: builder.mutation({
      query: (values) => ({
        url: "/department/create",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Department"],
    }),
    updateDepartment: builder.mutation({
      query: (values) => ({
        url: "/department/update",
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["Department"],
    }),
    deleteDepartment: builder.mutation({
      query: (values) => ({
        url: `/department/${values.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Department"],
    }),
  }),
});

export const {
  useGetDepartmentQuery,
  useGetDepartmentsPaginatedQuery,
  useCreateDepartmentMutation,
  useUpdateDepartmentMutation,
  useDeleteDepartmentMutation,
} = departmentsApiSlice;
